var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitoringIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3682 10.2568L14.7812 12.866C17.3539 14.3871 18.3823 14.3871 20.9551 12.866L25.3681 10.2568",
    stroke: "#5C11A7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8862 29.4474V26.2896",
    stroke: "#5C11A7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8333 29.4474V21.5527",
    stroke: "#5C11A7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7805 29.4473V24.7105",
    stroke: "#5C11A7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3335 25.5001C17.3335 21.9646 17.3335 20.1968 18.4318 19.0985C19.5302 18.0001 21.2979 18.0001 24.8334 18.0001C28.3689 18.0001 30.1367 18.0001 31.2351 19.0985C32.3334 20.1968 32.3334 21.9646 32.3334 25.5001C32.3334 29.0355 32.3334 30.8033 31.2351 31.9017C30.1367 33 28.3689 33 24.8334 33C21.2979 33 19.5302 33 18.4318 31.9017C17.3335 30.8033 17.3335 29.0355 17.3335 25.5001Z",
    stroke: "#5C11A7",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33 15.4677L32.9384 9.65743C32.9217 7.44427 31.7268 3.01797 27.0808 3.01797H9.1579C7.10527 2.86701 3 3.52077 3 10.7134V21.3771C3.00001 23.208 3.40843 25.6725 5.41619 27.1582C6.71365 28.1184 8.41676 28.2073 10.0262 28.287L13.3967 28.4538",
    stroke: "#5C11A7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitoringIcon);
export default __webpack_public_path__ + "static/media/monitoring-icon.6fa1ec0bafcd8c6df1c5c64de6b5fa12.svg";
export { ForwardRef as ReactComponent };